import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant, AppConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";

export default function useChannelAddMember() {
  const { t: getLabel } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ groupId, memberIds }) => {
      const payload = qs.stringify(
        HumpUtils.decamelizeKeys({ groupId, memberIds, memberInviteType: AppConstant.CHANNEL_MEMBER_TYPE.member }),
      );
      const response = await ApiUtils.createApiWithToken(false).post(ApiConstant.POST_ADD_MEMBERS, payload);
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onSuccess, onError }) => {
      if ([ApiConstant.STT_OK, ApiConstant.STT_CONFLICT].includes(response?.status)) {
        SystemUtils.appendNotification(getLabel("TXT_ADD_CHANNEL_MEMBER_SUCCESS"), "success");
        await queryClient.invalidateQueries(ApiConstant.REACT_QUERY_KEYS.getChannelList);
        onSuccess?.();
      } else {
        SystemUtils.appendNotification(getLabel("TXT_ADD_CHANNEL_MEMBER_FAIL"), "error");
        onError?.();
      }
    },
    onError: (_, { onError }) => {
      SystemUtils.appendNotification(getLabel("TXT_TIMEOUT"), "error");
      onError?.();
    },
  });

  const addChannelMembers = payload => {
    mutation.mutate(payload);
  };

  return { addChannelMembers, isLoading: mutation.isLoading };
}
